import { FORMATTED_GRADES } from 'a/hub/data/constants';
import assessmentIds from 'a/hub/data/AssessmentIds';

export const DEFAULT_FONT = 'Open Sans';

export const SELECTED_PRODUCT_KEY = 'selectedProduct';
export const PRODUCT_READING = 'reading';
export const PRODUCT_LECTURA = 'lectura';
export const PRODUCT_EXPERIENCES = [PRODUCT_READING, PRODUCT_LECTURA];
export const PRODUCT_NOT_YET_SELECTED = 'NA';
export const PRODUCT_READING_CAP = 'Reading';
export const PRODUCT_LECTURA_CAP = 'Lectura';
export const PRODUCT_READING_ALL_CAPS = 'READING';
export const PRODUCT_LECTURA_ALL_CAPS = 'LECTURA';
export const N_A = 'Not Applicable';

export const LOGIN_METADATA = 'loginMetadata';
export const LOCAL_STORAGE_TAB_ID = 'lsTabId';
export const SESSION_STORAGE_TAB_ID = 'ssTabId';
export const END_OF_QUESTS_MODAL_SEEN_KEY = 'endOfAllQuestsModalSeenInSession';

export const GAME_MODE = {
  DEMO: 'DEMO_MODE',
  QUEST: 'QUEST_MODE',
  PRACTICE: 'PRACTICE_MODE',
  PRACTICE_LINK: 'PRACTICE_LINK_MODE',
  ASSIGNMENT_LINK: 'ASSIGNMENT_LINK_MODE',
  TEACHER_LINK: 'TEACHER_LINK_MODE',
};

// relationship between deep link mode and game mode
export const DEEP_LINK_GAME_MODE = {
  practice: GAME_MODE.PRACTICE_LINK,
  assignment: GAME_MODE.ASSIGNMENT_LINK,
  teacher: GAME_MODE.TEACHER_LINK,
};

export const DEEP_LINK_MODES = {
  PRACTICE: 'practice',
  ASSIGNMENT: 'assignment',
  TEACHER: 'teacher',
};

export const ASSIGNMENT_LINK_STATUS = {
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'inProgress',
  COMPLETE: 'complete',
};

export const LANGUAGES = {
  EN: 'en',
  ES: 'es',
};

export const LOCALIZATIONS = {
  EN: 'en',
  ES: 'es',
  SPA_ES_DEFAULT: 'spa-es-default',
};

export const STANDARD_PRESS_RETENTION = {
  top: 150,
  left: 150,
  right: 150,
  bottom: 150,
};

export const Environment = {
  LOCALDEV: 'localdev',
  SANDBOX: 'sandbox',
  DEV: 'dev',
  CI: 'ci',
  DEVCI: 'devci',
  STAGING: 'staging',
  PROD: 'prod',
};

// For testing the API and mocking during Jest tests
export const TestEnv = {
  ENVIRONMENT: 'test',
  API_VERSION_KEYCLOAK: '1',
  API_VERSION: '2',
  API_URL: 'test_api_url',
  KEYCLOAK_URL: 'test_keycloak_url',
  SEARCHLIGHT_API_VERSION: '3',
  SEARCHLIGHT_SCHEMA_VERSION: '0.0',
  SEARCHLIGHT_URL: 'test_searchlight_url',
  LOGIN_URL: 'test_login_url',
  TEACHER_DASHBOARD_URL: 'test_teacherdash_url',
  GA_KEY: '123',
  GAME_CONTENT_URL: 'test_game_content_url',
  ROBOVOICE_URL: 'test_robovoice_url',
  isDev: false,
  isSandbox: false,
  isProd: false,
  isDevEnv: false,
};

export const GlobalColors = {
  ALL_COLORS: {
    CHERRY_RED_LIGHT: '#FFD2DD',
    CHERRY_RED_DARK: '#E71D32',
    SWEET_ORANGE_LIGHT: '#FFDDA3',
    SWEET_ORANGE_DARK: '#D74108',
    GRASS_GREEN_LIGHT: '#C8F08F',
    GRASS_GREEN_DARK: '#4B8400',
    AQUA_TEAL_LIGHT: '#A7FAE6',
    AQUA_TEAL_DARK: '#008571',
    SKY_BLUE_LIGHT: '#C0E6FF',
    SKY_BLUE_DARK: '#3B74BE',
    VIOLET_PURPLE_LIGHT: '#EED2FF',
    VIOLET_PURPLE_DARK: '#9651D4',
    CUTE_PINK_LIGHT: '#FFD2FF',
    CUTE_PINK_DARK: '#DB2780',
    NEUTRAL_GREY_LIGHT: '#E0E0E0',
    NEUTRAL_GREY_DARK: '#777677',
    WARM_GREY_LIGHT: '#E9E0E0',
    WARM_GREY_DARK: '#7D7373',
    COOL_GREY_LIGHT: '#DFE9E9',
    COOL_GREY_DARK: '#6D7777',
  },
  LIGHT: {
    CHERRY_RED: '#FFD2DD',
    SWEET_ORANGE: '#FFDDA3',
    GRASS_GREEN: '#C8F08F',
    AQUA_TEAL: '#A7FAE6',
    SKY_BLUE: '#C0E6FF',
    VIOLET_PURPLE: '#EED2FF',
    CUTE_PINK: '#FFD2FF',
    NEUTRAL_GREY: '#E0E0E0',
    WARM_GREY: '#E9E0E0',
    COOL_GREY: '#DFE9E9',
  },
  DARK: {
    CHERRY_RED: '#E71D32',
    SWEET_ORANGE: '#D74108',
    GRASS_GREEN: '#4B8400',
    AQUA_TEAL: '#008571',
    SKY_BLUE: '#3B74BE',
    VIOLET_PURPLE: '#9651D4',
    CUTE_PINK: '#DB2780',
    NEUTRAL_GREY: '#777677',
    WARM_GREY: '#7D7373',
    COOL_GREY: '#6D7777',
  },
};

export const SEASONAL_FEATURE_IDS = {
  HALLOWEEN: 'HALLOWEEN',
};

export const MINUTES_UNTIL_TIMEOUT = 115; // 1 hour 55 minutes, aligned with Keycloak session idle (2 hours)

export const DEFAULT_COUNTRY = 'en';

export const PROMISE_STATUSES = {
  FULFILLED: 'fulfilled',
  PENDING: 'pending',
  REJECTED: 'rejected',
};

export const API_LICENSES_KEYS = {
  READING: PRODUCT_READING_CAP,
  LECTURA: PRODUCT_LECTURA_CAP,
};

export const ASSIGNED_PRODUCT_OPTIONS = {
  READING: PRODUCT_READING,
  LECTURA: PRODUCT_LECTURA,
  STUDENT_CHOICE: 'Student Choice',
};

export const PRODUCTS = {
  READING: 'product-reading',
  LECTURA: 'product-lectura',
};

export const LICENSE_TYPES = ['Standard', 'Trial'];

// Mobile
export const MIN_IOS_VERSION = 15;

export const MIN_MOBILE_SAFARI_VERSION = Math.floor(MIN_IOS_VERSION);

// Desktop
export const MIN_SAFARI_VERSION = 13;

// <------------- USAGE TAGGING CONSTS ------------->
const APPS = {
  [PRODUCT_READING]: 'Boost Reading',
  [PRODUCT_LECTURA]: 'Boost Lectura',
};

export const PROGRAMS = {
  ...APPS,
  ELA: 'Amplify ELA',
  CKLA: 'Amplify CKLA',
  CAMINOS: 'Amplify Caminos',
};

const LANGUAGE_OPTIONS = {
  [LOCALIZATIONS.EN]: 'English',
  [LOCALIZATIONS.ES]: 'Spanish Voiceover',
  [LOCALIZATIONS.SPA_ES_DEFAULT]: 'Spanish',
};

const LOCATIONS = {
  METAGAME: 'Metagame',
  BACKPACK: 'Backpack', // Seasons 1&2 only
  WORKSHOP: 'Workshop',
  PROGRESS: 'Progress Page', // Season 3 only - similar to backpack
};

const ASSESSMENTS = {
  [assessmentIds.SKILL_SCAN]: 'Skill Scan',
  [assessmentIds.SKILL_SCAN_AGGREGATE]: 'Skill Scan',
  [assessmentIds.PLACEMENT_TOOL]: 'Placement', // APT
  [assessmentIds.ARBA]: 'Boost Reading Benchmark Assessment', // TRO-APT
  [assessmentIds.TRO_BENCHMARK]: 'Benchmark', // TRO reset and BenchmarkEOY
};

const FORMATTED_GAME_MODES = {
  [GAME_MODE.DEMO]: 'Demo',
  [GAME_MODE.QUEST]: 'Quest',
  [GAME_MODE.PRACTICE]: 'Practice',
  [GAME_MODE.PRACTICE_LINK]: 'Practice Link',
  [GAME_MODE.ASSIGNMENT_LINK]: 'Assignment Link',
  [GAME_MODE.TEACHER_LINK]: 'Teacher Link',
};

const QUEST_TYPES = {
  QUEST: 'Quest', // 'Quest 1', 'Quest 2', 'Quest 3', etc
  SIDE_QUEST: 'Side Quest',
  CHALLENGE_QUEST: 'Challenge Quest',
};

const GAME_PARTS = {
  ONBOARDING: 'Onboarding',
  SCAFFOLDING: 'Scaffolding', // placeholder - for in-level Instruction/Practice
  STANDARD: 'Standard Play',
};

const CAPTIONS_ON = 'On';

export const USAGE_TAGS = {
  PROGRAM_USE: { prefix: 'Program Use', value: 'Supplementals' },
  SUITE: { prefix: 'Suite', value: 'Literacy' },
  APP: { prefix: 'App', value: APPS },
  PROGRAM: { prefix: 'Program', value: PROGRAMS },
  LANGUAGE: { prefix: 'Language', value: LANGUAGE_OPTIONS },
  GRADE: { prefix: 'Grade', value: FORMATTED_GRADES },
  SEASON: { prefix: 'Season' },
  // above ^^ values should not change within one session //
  LOCATION: { prefix: 'Location', value: LOCATIONS },
  ASSESSMENT: { prefix: 'Assessment', value: ASSESSMENTS },
  GAME_MODE: { prefix: 'Game Mode', value: FORMATTED_GAME_MODES },
  QUEST_TYPE: { prefix: 'Quest Type', value: QUEST_TYPES },
  SKILL_ID: { prefix: 'Skill Id' },
  GAME_PART: { prefix: 'Game Part', value: GAME_PARTS },
  LEVEL: { prefix: 'Level' },
  BOOK_TITLE: { prefix: 'Book Title' },
  CAPTIONS: { prefix: 'Captions', value: CAPTIONS_ON },
};

export const API_REQUEST_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
